<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">New Management</div>
      </div>
      <div class="card-content">
        <form method="#" action="#">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Full Name</label>
                <input type="text" v-model.lazy="editForm.name"  placeholder="John Doe" class="form-control"
                v-validate="modelValidations.name" name="name">
                <small class="text-danger" v-show="name.invalid">
                    {{ getError('name') }}
                </small>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Email address</label>
                <input type="email" v-model.lazy="editForm.email" placeholder="example@examplesite.com" class="form-control"
                v-validate="modelValidations.email" name="email">
                <small class="text-danger" v-show="email.invalid">
                    {{ getError('email') }}
                </small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Username</label>
                <input type="text" v-model.lazy="editForm.username" placeholder="jdoe" class="form-control"
                v-validate="modelValidations.username" name="username">
                <small class="text-danger" v-show="username.invalid">
                  {{ getError('username') }}
                </small>  
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Password</label>
                <div class="input-group">
                  <input v-validate="modelValidations.password" name="password"
                  :type="!showPassword ? 'password' : 'text'" v-model.lazy="editForm.password" class="form-control">
                  <span class="input-group-btn">
                    <button @click.prevent="editForm.password=randomWord(8)" tabindex="-1" type="button" class="btn" style="border-color: #DDD">
                      <i class="ti-key"></i> Generate
                    </button>
                    <button @click.prevent="showPassword=!showPassword" tabindex="-1" type="button" class="btn form-btn" v-html="passwordButton">
                    </button>
                  </span>
                </div>
                <small class="text-danger" v-show="password.invalid">
                  {{ getError('password') }}
                </small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" v-if="$store.state.managerData.GroupId===0">
                <label>Group</label><br>
                <el-select
                  filterable
                  name="group"
                  placeholder="Select Group"
                  class="select-success"
                  size="small"
                  v-model="editForm.group"
                  v-validate="modelValidations.group">
                  <el-option label="PFTC" value="0"></el-option>
                  <el-option v-for="group in $store.state.managerData.groups" :label="group.GroupName" :key="group.GroupId" :value="group.GroupId"></el-option>
                </el-select>
                <small class="text-danger" v-show="group.invalid">
                    {{ getError('group') }}
                </small>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Role</label><br>
                <el-select
                  class="select-success"
                  size="small"
                  v-model="editForm.role">
                  <el-option label="Manager" value="Manager"></el-option>
                  <el-option label="Admin" value="Admin"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <button  type="submit" @click.prevent="validate" class="btn btn-fill btn-info">Create New {{editForm.role}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Current Management</div>
      </div>
      <div class="card-content row">
        <div class="col-sm-4">
            <input type="search" class="form-control input-sm" placeholder="Search managers" v-model="searchQuery" aria-controls="datatables"><br>
        </div>
        <div class="col-sm-8">
        </div>
        <div class="col-sm-12">
          <el-table class="table-striped"
                    :data="queriedData"
                    border
                    style="width: 100%">
            <el-table-column v-for="column in tableColumns"
                             :key="column.label"
                             :min-width="column.minWidth"
                             :prop="column.prop"
                             :label="column.label"
                             :formatter="column.formatter">
            </el-table-column>
            <el-table-column
              label="Delete" width="70" align="center">
              <template slot-scope="scope">
                <button class="btn btn-sm btn-fill btn-danger" type="button"
                  @click="deleteManager(scope.row)">X</button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Showing {{resultTotal}} of {{total}} managers</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import { mapFields } from 'vee-validate'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    computed: {
      ...mapFields(['name', 'username', 'email', 'password', 'group']),
      queriedData () {
        if (!this.searchQuery) {
          this.resultTotal = this.tableData.length
          return this.tableData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString().toLowerCase()
              if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                isIncluded = true
              }
              if (key === 'GroupId') {
                let groupId = row[key]
                let groupName = groupId === 0 ? 'pftc' : this.$store.state.managerData.groups.find(group => group.GroupId === groupId).GroupName.toLowerCase()
                if (groupName.includes && groupName.includes(this.searchQuery.toLowerCase())) {
                  isIncluded = true
                }
              }
            }
            return isIncluded
          })
        this.resultTotal = result.length
        return result
      },
      passwordButton () {
        return this.showPassword ? '<i class="ti-lock"></i> Hide' : '<i class="ti-eye"></i> Show'
      },
      total () {
        this.resultTotal = this.tableData.length
        return this.tableData.length
      }
    },
    data () {
      return {
        showPassword: false,
        resultTotal: 0,
        searchQuery: '',
        editForm: {
          name: '',
          email: '',
          username: '',
          password: '',
          role: 'Manager',
          group: ''
        },
        modelValidations: {
          name: {
            required: true,
            min: 3
          },
          email: {
            email: true,
            required: true
          },
          username: {
            required: true,
            min: 3
          },
          password: {
            min: 6,
            required: true
          },
          group: {
            required: true
          }
        },
        propsToSearch: ['Name', 'Email', 'Role', ...(this.$store.state.managerData.GroupId === 0 ? ['GroupId'] : [])],
        tableColumns: [
          {
            prop: 'Name',
            label: 'Name',
            minWidth: 110
          },
          {
            prop: 'Username',
            label: 'Username',
            minWidth: 110
          },
          {
            prop: 'Email',
            label: 'Email',
            minWidth: 100
          },
          {
            prop: 'Role',
            label: 'Role',
            minWidth: 70
          },
          ...(this.$store.state.managerData.GroupId === 0
          ? [
            {
              prop: 'GroupId',
              label: 'Group',
              minWidth: 70,
              formatter: (row, column, cellValue) => {
                return cellValue === 0 ? 'PFTC' : this.$store.state.managerData.groups.find(group => group.GroupId === cellValue).GroupName
              }
            }
          ] : [])
        ],
        tableData: []
      }
    },
    methods: {
      newManager () {
        this.$http.post('/manager/create', this.editForm)
          .then((response) => {
            this.tableData = response.data
            this.editForm = {
              name: '',
              email: '',
              username: '',
              password: '',
              group: '',
              role: 'Manager'
            }
            this.$nextTick(() => this.$validator.reset())
            this.$notify({
              component: {
                template: `<span><b>Manager Created</b> - The manager was successfully created.</span>`
              },
              icon: 'ti-close',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success'
            })
          })
      },
      deleteManager (manager) {
        this.$http.post('/manager/delete', manager)
          .then((response) => {
            this.tableData = response.data
            this.$notify({
              component: {
                template: `<span><b>Manager Deleted</b> - The manager was permanently deleted.</span>`
              },
              icon: 'ti-close',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success'
            })
          })
      },
      randomWord (length) {
        const vowels = ['a', 'e', 'i', 'o', 'u']
        const consts = ['b', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'm', 'n', 'p', 'r', 's', 't', 'v', 'w', 'y', 'z', 'ch', 'sh', 'th']
        let word = ''
        let isVowel = false
        let arr

        for (let i = 0; i < length; i++) {
          if (isVowel) {
            arr = vowels
          } else {
            arr = consts
          }
          isVowel = !isVowel
          word += arr[Math.round(Math.random() * (arr.length - 1))]
        }
        return word
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.$emit('on-submit', this.model)
            this.newManager()
          }
        })
      }
    },
    created () {
      this.$http.get('/manager/getManagers')
        .then((response) => {
          this.tableData = response.data
        })
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Managers.vue